export const LISTING_FILTER_PARAM_KEYS = [
	"makes",
	"models",
	"trims",
	"suppliers",
	"fuelTypes",
	"transmissions",
	"saleTypes",
	"colors",
	"doors",
	"seats",
	"markets",
	"minYear",
	"maxYear",
	"minPrice",
	"maxPrice",
	"minSellPrice",
	"maxSellPrice",
	"minMileage",
	"maxMileage",
	"minEnginePower",
	"maxEnginePower",
	"minCo2Emission",
	"maxCo2Emission",
	"onlyFavorites",
	"hasInspectionReport",
	"hideDamaged",
	"hideNonOperable",
	"onlyDamaged",
	"onlyNonOperable",
	"appraisalStatus",
	"isBrandNew",
	"searchText",
	"regionCodes",
	"provinceCodes",
	"centerLat",
	"centerLng",
	"centerLabel",
	"radiusKm",
	"conditionGrades",
	"includeUngraded",
];

export function applyFilterParams(
	params: URLSearchParams,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	filterParams: Record<string, any>
): void {
	Object.entries(filterParams).forEach(([key, value]) => {
		if (value !== undefined && value !== null) {
			if (Array.isArray(value)) {
				if (value.length > 0) {
					params.set(key, value.join(","));
				}
			} else {
				params.set(key, value.toString());
			}
		}
	});
}
